import { render } from "./LoginByLink.vue?vue&type=template&id=4021c863&scoped=true&ts=true"
import script from "./LoginByLink.vue?vue&type=script&lang=ts"
export * from "./LoginByLink.vue?vue&type=script&lang=ts"

import "./LoginByLink.vue?vue&type=style&index=0&id=4021c863&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4021c863"]])

export default __exports__